module.exports = __webpack_public_path__ + "static/media/05_insideyourblood.b9204a90.jpg";